import { defineMessages } from 'react-intl';

export default defineMessages({
  name: 'Category Name',
  newName: 'New Category Name',
  path: 'Category ID Path',
  success: 'Category renamed',
  title: 'Rename Category'
});
